import { FaIcon, faIdBadge } from '@/lib/fa'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { faClose } from '@fortawesome/pro-light-svg-icons'
import React from 'react'

const TachoDiscHaeder = ({ onClose,driverName }) => {
  const { t } = useLocalize()
  return (
    <div className="tw-flex tw-items-center tw-justify-between  tw-py-4">
      <div className="tw-ml-4 tw-flex tw-items-center tw-gap-2">
        <p className="tw-m-0 tw-text-xl tw-font-semibold tw-text-content-base">
         Tarczka
        </p>
        {driverName && (
          <div className="tw-flex tw-items-center tw-gap-1 tw-text-sm">
            <div className="tw-flex tw-items-center tw-gap-1 tw-rounded tw-bg-base-300 tw-px-1">
              <FaIcon icon={faIdBadge} className="tw-cursor-pointer" />
              <span>{driverName}</span>
            </div>
          </div>
        )}
      </div>
      <div
        onClick={() => {
          onClose?.()
        }}
        className="tw-flex tw-cursor-pointer tw-items-center tw-gap-4"
      >
        <FaIcon
          icon={faClose}
          className="tw-mr-4 tw-h-5 tw-w-5 tw-cursor-pointer "
        />
      </div>
    </div>
  )
}

export default TachoDiscHaeder
